<template>
  <v-form ref="form" :value="valid" @input="v => $emit('update:valid', v)">
    <v-row align="center" dense no-gutters>
      <span>Mesure pour l'inventaire</span>
    </v-row>
    <v-row align="center" dense>
      <v-col cols="12" sm="3">
        <j-decimal-input
          :hide-details="$vuetify.breakpoint.xsOnly"
          filled
          dense
          class="no-before"
          :value="prix_inventory"
          label="Prix"
          @input="v => $emit('update:prix_inventory', v)"
          suffix="$"
          required
          :min="0"
          :readonly="getUseOrderQuantityModel"
        ></j-decimal-input>
      </v-col>
      <v-col cols="6" sm="3">
        <j-decimal-input
          :hide-details="$vuetify.breakpoint.xsOnly"
          filled
          dense
          class="no-before"
          :value="quantity_inventory"
          label="Quantité"
          required
          :min="0.0001"
          @input="v => $emit('update:quantity_inventory', v)"
        ></j-decimal-input>
      </v-col>
      <v-col cols="6" sm="3">
        <v-autocomplete
          :hide-details="$vuetify.breakpoint.xsOnly"
          filled
          dense
          class="no-before"
          :value="unite_mesure_inventory"
          :items="getAllowedUnits"
          label="Unité"
          required
          :rules="[
            v => v !== null || 'Une unité de mesure est nécessaire',
            v => v !== undefined || 'Une unité de mesure est nécessaire'
          ]"
          @change="v => $emit('update:unite_mesure_inventory', v)"
        ></v-autocomplete>
      </v-col>
      <v-col cols="12" sm="3" style="text-align: center;">
        <v-row align="center" justify="end" no-gutters>
          <span class="subtitle-1">{{
            `${getPrice}$ par ${unite_mesure_inventory}`
          }}</span>
        </v-row>
      </v-col>
    </v-row>
    <v-row align="center">
      <v-col cols="12">
        <v-checkbox
          hide-details
          v-model="getUseConversionFormulaModel"
          label="Utiliser une mesure différente pour la production"
        ></v-checkbox>
      </v-col>
    </v-row>
    <section v-if="getUseConversionFormulaModel">
      <v-row align="center" dense>
        <v-col cols="8" sm="3">
          <j-decimal-input
            :hide-details="$vuetify.breakpoint.xsOnly"
            filled
            dense
            class="no-before"
            :value="quantity_inventory"
            label="Quantité d'inventaire"
            read-only
            :min="0.0001"
            :required="getUseConversionFormulaModel === true"
            @change="v => $emit('update:quantity_inventory', v)"
            :suffix="unite_mesure_inventory"
          ></j-decimal-input>
        </v-col>
        <span class="gutters subtitle-1">équivaut à</span>
        <v-col cols="6" sm="3">
          <j-decimal-input
            :hide-details="$vuetify.breakpoint.xsOnly"
            filled
            dense
            class="no-before"
            :value="quantity_production"
            label="Quantité de production"
            :min="0.0001"
            :required="getUseConversionFormulaModel === true"
            @change="v => $emit('update:quantity_production', v)"
          ></j-decimal-input>
        </v-col>
        <v-col cols="6" sm="2">
          <v-autocomplete
            :hide-details="$vuetify.breakpoint.xsOnly"
            filled
            dense
            class="no-before"
            :value="unite_mesure"
            :rules="[
              v => v !== null || 'Une unité de mesure est nécessaire',
              v => v !== undefined || 'Une unité de mesure est nécessaire'
            ]"
            :items="getAllowedUnits"
            label="Unité"
            :required="getUseConversionFormulaModel === true"
            @change="v => $emit('update:unite_mesure', v)"
          ></v-autocomplete>
        </v-col>
      </v-row>
      <v-row align="center">
        <v-col cols="12">
          <v-checkbox
            hide-details
            v-model="getUseAlternativeUnitModel"
            label="Permettre une seconde unité pour la production"
          ></v-checkbox>
        </v-col>
      </v-row>
      <section v-if="use_alternative_unit === true">
        <v-row align="center" dense>
          <v-col cols="8" sm="3">
            <j-decimal-input
              :hide-details="$vuetify.breakpoint.xsOnly"
              filled
              dense
              class="no-before"
              :value="alternative_quantity_inventory"
              label="Quantité d'inventaire"
              :min="0.0001"
              :required="use_alternative_unit === true"
              @change="v => $emit('update:alternative_quantity_inventory', v)"
              :suffix="unite_mesure_inventory"
            ></j-decimal-input>
          </v-col>
          <span class="gutters subtitle-1">équivaut à</span>
          <v-col cols="6" sm="3">
            <j-decimal-input
              :hide-details="$vuetify.breakpoint.xsOnly"
              filled
              dense
              class="no-before"
              :value="alternative_quantity_production"
              label="Quantité de production"
              :min="0.0001"
              :required="use_alternative_unit === true"
              @change="v => $emit('update:alternative_quantity_production', v)"
            ></j-decimal-input>
          </v-col>
          <v-col cols="6" sm="2">
            <v-autocomplete
              :hide-details="$vuetify.breakpoint.xsOnly"
              filled
              dense
              class="no-before"
              :value="alternative_unite_mesure_production"
              :rules="[
                v => v !== null || 'Une unité de mesure est nécessaire',
                v => v !== undefined || 'Une unité de mesure est nécessaire'
              ]"
              :items="getAllowedUnits"
              label="Unité"
              @change="
                v => $emit('update:alternative_unite_mesure_production', v)
              "
            ></v-autocomplete>
          </v-col>
        </v-row>
      </section>
    </section>
    <v-row align="center">
      <v-col cols="12">
        <v-checkbox
          hide-details
          v-model="getUseOrderQuantityModel"
          label="Utiliser une mesure différente pour les commandes"
        ></v-checkbox>
      </v-col>
    </v-row>
    <section v-if="getUseOrderQuantityModel">
      <!-- <v-row align="center" dense>
        <v-col cols="10" sm="4">
          <v-text-field
            label="Produit lié"
            hint="Laisser vide pour ignorer"
            persistent-hint
            filled
            dense
            class="no-before"
            :value="supplier_product_link_name"
            readonly
          ></v-text-field>
        </v-col>
        <v-col>
          <div style="padding-bottom: 22px;">
            <GlobalSupplierProductSelector
              @link="setProductLink"
              @unlink="unlinkProduct"
            ></GlobalSupplierProductSelector>
          </div>
        </v-col>
      </v-row> -->
      <v-row align="center" dense>
        <v-col cols="12" sm="3">
          <j-decimal-input
            :hide-details="$vuetify.breakpoint.xsOnly"
            filled
            dense
            class="no-before"
            :value="price_order"
            label="Prix de commande"
            :min="0.01"
            :required="getUseOrderQuantityModel === true"
            @input="v => $emit('update:price_order', v)"
            suffix="$"
          ></j-decimal-input>
        </v-col>
        <v-col cols="8" sm="2">
          <j-decimal-input
            :hide-details="$vuetify.breakpoint.xsOnly"
            filled
            dense
            class="no-before"
            :value="quantity_order"
            label="Quantité de commande"
            :min="0.0001"
            :required="getUseOrderQuantityModel === true"
            @change="v => $emit('update:quantity_order', v)"
          ></j-decimal-input>
        </v-col>
        <v-col cols="4" sm="2">
          <v-autocomplete
            :hide-details="$vuetify.breakpoint.xsOnly"
            filled
            dense
            class="no-before"
            :value="unite_mesure_order"
            :rules="[
              v => v !== null || 'Une unité de mesure est nécessaire',
              v => v !== undefined || 'Une unité de mesure est nécessaire'
            ]"
            :items="getAllowedUnits"
            label="Unité"
            @change="v => $emit('update:unite_mesure_order', v)"
          ></v-autocomplete>
        </v-col>

        <span class="gutters subtitle-1">équivaut à</span>

        <v-col cols="6" sm="3">
          <j-decimal-input
            :hide-details="$vuetify.breakpoint.xsOnly"
            filled
            dense
            class="no-before"
            :value="quantity_inventory_order"
            label="Quantité d'inventaire"
            :min="0.0001"
            :required="getUseOrderQuantityModel === true"
            @change="v => $emit('update:quantity_inventory_order', v)"
            :suffix="unite_mesure_inventory"
          ></j-decimal-input>
        </v-col>
      </v-row>
    </section>
  </v-form>
</template>

<script>
import { mapGetters } from "vuex";
import { rulesMixin } from "@/mixins/rulesMixins";
import { mappers } from "@/mappers";
import { round10 } from "round10";
// import { GlobalSupplierProductSelector } from "@/modules/GlobalSuppliers/components";
export default {
  mixins: [rulesMixin],
  name: "RecipeProductPriceInput",
  props: {
    prix: {
      required: true
    },
    unite_mesure: {
      required: true
    },
    unite_mesure_inventory: {
      required: true
    },
    prix_inventory: {
      required: true
    },
    quantity_production: {
      required: true
    },
    quantity_inventory: {
      required: true
    },
    conversion_formula: {
      required: true
    },
    use_conversion_formula: {
      type: Boolean,
      required: true
    },
    est_intermediaire: {
      type: Boolean
    },
    use_order_quantity: {
      type: Boolean,
      required: true
    },
    price_order: {
      required: true
    },
    quantity_order: {
      required: true
    },
    quantity_inventory_order: {
      required: true
    },
    unite_mesure_order: {
      required: true
    },
    supplier_product_link: {
      required: true
    },
    supplier_product_link_name: {
      required: true
    },
    use_alternative_unit: {
      required: true
    },
    alternative_quantity_production: {
      required: true
    },
    alternative_quantity_inventory: {
      required: true
    },
    alternative_unite_mesure_production: {
      required: true
    },
    valid: {
      type: Boolean,
      required: true
    }
  },
  computed: {
    ...mapGetters(["getAllowedUnits"]),
    getUseConversionFormulaModel: {
      get() {
        return this.use_conversion_formula;
      },
      set(newValue) {
        this.$emit("update:use_conversion_formula", newValue);
      }
    },
    getUseOrderQuantityModel: {
      get() {
        return this.use_order_quantity;
      },
      set(newValue) {
        this.$emit("update:use_order_quantity", newValue);
      }
    },
    getUseAlternativeUnitModel: {
      get() {
        return this.use_alternative_unit;
      },
      set(newValue) {
        this.$emit("update:use_alternative_unit", newValue);
      }
    },
    getPrice() {
      return round10(this.prix_inventory / this.quantity_inventory, -4);
    }
  },
  data() {
    return {
      formulaError: false
    };
  },
  methods: {
    getPriceInventory() {
      const data = {
        price_order: this.price_order,
        quantity_order: this.quantity_order,
        quantity_inventory_order: this.quantity_inventory_order
      };
      this.$emit(
        "update:prix_inventory",
        round10(mappers.productGetNewInvPrice(data), -2)
      );
    },
    setProductLink(value) {
      this.$emit("update:supplier_product_link_name", value.name);
      this.$emit("update:supplier_product_link", value.id);
      this.$emit("update:price_order", +value.prix);
      this.$emit("update:quantity_order", +value.format);
      this.$emit("update:quantity_inventory_order", +value.format);
      this.$emit("update:unite_mesure_order", value.unit);
      this.$emit("update:unite_mesure_inventory", value.unit);
    },
    unlinkProduct() {
      this.$emit("update:supplier_product_link_name", null);
      this.$emit("update:supplier_product_link", null);
    }
  },
  watch: {
    price_order(v, oldV) {
      if (v !== oldV && this.use_order_quantity) {
        this.getPriceInventory();
      }
    },
    quantity_order(v, oldV) {
      if (v !== oldV && this.use_order_quantity) {
        this.getPriceInventory();
      }
    },
    quantity_inventory_order(v, oldV) {
      if (v !== oldV && this.use_order_quantity) {
        this.getPriceInventory();
      }
    },
    unite_mesure_order(v, oldV) {
      if (v !== oldV && this.use_order_quantity) {
        this.getPriceInventory();
      }
    }
  }
};
</script>

<style scoped>
.gutters {
  padding: 4px;
}
</style>
